module.exports = __webpack_public_path__ + "static/media/layout-3.06b3c203.jpg";